// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JsJrc","scroller":"styles_scroller__pcTOQ","stayTypeIcon":"styles_stayTypeIcon__IGhV4","icons":"styles_icons__q9Tx1"};